import flowRight from 'lodash/flowRight'
import transformProps from 'loankeeper-common/containers/transformProps'

import withLivedata from '../../shared/containers/withLivedata'
import withLookups from '../../shared/containers/withLookups'
import { withSystemConfig } from '../../shared'
import withConstantPermissions from '../../shared/containers/withConstantPermissions'

export default flowRight(
  withLivedata('OpenDayStatus.Open_Day_Str as OpenDay'),
  withLivedata('OpenDayStatus.Cur_Date as CurrentDay'),
  withLookups({ type: 'sys', query: 'CCY' }),
  withLookups({ type: 'acc', query: 'OpCode' }),
  withConstantPermissions(),
  withSystemConfig('CellPhoneValidate'),

  transformProps((props) => {
    // OperTypeID is passed to every component
    const filteredOpCodes = props.OpCode.filter((code) => code.EntryOperTypeID === props.OperTypeID || code.ID === 0)

    return {
      ...props,
      CCY: props.CCY.map((curr) => ({ ID: curr.ISO, Title: curr.ISO })),
      OpCode: filteredOpCodes.map((code) => ({
        ID: code.ID,
        Destination: code.Destination,
        Title: `${code.Code} - ${code.Destination}`,
      })),
    }
  }),
)
